import React from 'react';
import Button from '../elements/button';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import '../../assets/css/store/shopping_cart.css';

const ShoppingCart = ({ onClose }) => {
    const { cartItems, removeFromCart, updateQuantity, calculateTotal, handleCheckout } = useCart();
    const { isAuthenticated } = useAuth();
    
    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-NG', {
            style: 'currency',
            currency: 'NGN'
        }).format(price);
    };
    
    const handleCheckoutClick = () => {
        if (!isAuthenticated) {
            onClose?.();
            return;
        }
        handleCheckout();
        onClose?.();
    };

    const handleClose = () => {
        onClose?.();
    };

    return (
        <div className="cart-modal" onClick={handleClose}>
            <div className="cart-content" onClick={(e) => e.stopPropagation()}>
                <div className="cart-header">
                    <h3>Your Cart</h3>
                    <button className="close-btn" onClick={handleClose}>×</button>
                </div>

                {cartItems.length === 0 ? (
                    <div className="empty-cart">
                        <p>Your cart is empty</p>
                        <Button 
                            text="Continue Shopping" 
                            variant="primary" 
                            onClick={handleClose} 
                        />
                    </div>
                ) : (
                    <>
                        <div className="cart-items">
                            {cartItems.map(item => (
                                <div key={item.id} className="cart-item">
                                    <img src={item.image} alt={item.name} />
                                    <div className="item-details">
                                        <h3>{item.name}</h3>
                                        <p>{formatPrice(item.price)}</p>
                                        <div className="quantity-controls">
                                            <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
                                            <span>{item.quantity}</span>
                                            <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                                        </div>
                                    </div>
                                    <button className="remove-item" onClick={() => removeFromCart(item.id)}>×</button>
                                </div>
                            ))}
                        </div>
                        <div className="cart-footer">
                            <div className="cart-total">
                                <span>Total</span>
                                <span>{formatPrice(calculateTotal())}</span>
                            </div>
                            {isAuthenticated ? (
                                <Button 
                                    text="Checkout" 
                                    variant="primary" 
                                    className="checkout-btn" 
                                    onClick={handleCheckoutClick}
                                    disabled={cartItems.length === 0}
                                />
                            ) : (
                                <div className="auth-checkout">
                                    <p>Please login to checkout</p>
                                    <Link to="/login" className="login-to-checkout" onClick={handleClose}>
                                        Login to Continue
                                    </Link>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ShoppingCart;